
// app/javascript/controllers/collection_select_controller.js
import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    console.log("collection_select_controller connected")
    this.choices = new Choices(this.selectTarget, {
      removeItemButton: true,
      searchResultLimit: 10,
      placeholderValue: "Kollektion auswählen...",
      searchPlaceholderValue: "Tippen zum Suchen ..."
    })

    // eigenes Such-Event abfangen
    this.selectTarget.addEventListener("search", this.fetchResults.bind(this))
  }

  async fetchResults(event) {
    // remove 'A_' to enable search
    const query = event.detail.value.replace(/a_/i, '')
    if (query.length < 3) return // erst ab 3 Zeichen suchen

    const response = await fetch(`/collections?q=${encodeURIComponent(query)}`)
    const data = await response.json()

    this.choices.setChoices(data, "value", "label", true)
  }
}

